import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoogleOneTapLogin } from '@react-oauth/google';
import { googleOneTapAuth } from '../../api/auth';
import { useAuth } from '../../contexts/AuthContext';

const GoogleOneTapAuth = () => {
    const navigate = useNavigate();
    const { setIsAuthenticated, isAuthenticated } = useAuth();

    const handleGoogleSuccess = useCallback(async credentialResponse => {
        try {
            // For Google One Tap, we get a JWT credential token
            // We need to send it to our backend API endpoint that handles JWT
            if (credentialResponse.credential) {
                await googleOneTapAuth(credentialResponse.credential);
                setIsAuthenticated(true);
                navigate('/chats');
            } else {
                console.error('No credential received from Google One Tap');
            }
        } catch (error) {
            console.error('Google authentication failed:', error);
        }
    }, [navigate, setIsAuthenticated]);

    const handleGoogleError = useCallback(() => {
        console.error('Google One Tap failed');
    }, []);

    useGoogleOneTapLogin({
        onSuccess: handleGoogleSuccess,
        onError: handleGoogleError,
        cancel_on_tap_outside: true,
        auto_select: false,
        disabled: isAuthenticated === true, // Disable if user is already authenticated
        use_fedcm_for_prompt: true, // Enable FedCM for One Tap (mandatory from Oct 2024)
    });

    // This component doesn't render anything visible as it's just the One Tap functionality
    return null;
};

export default GoogleOneTapAuth;
